import { routes } from '@/routes'
import { ButtonLink } from '@/components/ui/Button'

export function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-24 text-center">
      <p className="text-5xl font-bold text-brand">404</p>
      <h1 className="mt-3 text-[17px] font-semibold text-ink lg:text-xl">
        Página não encontrada
      </h1>
      <p className="mt-2 text-sm text-ink-soft">
        O endereço acessado não existe ou foi movido.
      </p>
      <ButtonLink to={routes.home} className="mt-6">
        Voltar para a home
      </ButtonLink>
    </div>
  )
}
